// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"_3EBpYZPzkiHRNB8WqNPPf0","content":"_3SJsSWeOnTprOeNmibYXjn","calendar":"q_QpWjfYpXx4awhV6JnF4"};